/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetStripeAccessDetailsForCustomerRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetStripeAccessDetailsForCustomer.pb'
import {GetStripeAccessDetailsForCustomerResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetStripeAccessDetailsForCustomer.pb'


export const getStripeAccessDetailsForCustomer = (request:GetStripeAccessDetailsForCustomerRequest, options?: CashRequestOptions) => post<GetStripeAccessDetailsForCustomerRequest, GetStripeAccessDetailsForCustomerResponse>("/2.0/cash/get-stripe-access-details-for-customer", request, {...options, rejectOnError: true })